var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length),expression:"items.length"}],staticClass:"print-footer"},[_c('p',{staticClass:"print-footer__line"},_vm._l((_vm.items),function(item){return _c('span',{key:item.key,attrs:{"dir":item.dir}},[_vm._v(_vm._s(item.text))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }